import {Injectable} from '@angular/core';
import {plainToInstance} from 'class-transformer';
import {ProcessModel} from './models/process.model';
import {ProcessesQuery} from './process.store';
import {map, switchMap} from 'rxjs/operators';
import {getBase64, MesApiService} from 'common-shared';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProcessService extends MesApiService {

  constructor(public query: ProcessesQuery) {
    super('process', 'manufacturing');
  }

  getAll$ = this.query.selectAll();

  loadOne(id: string) {
    return this.getSingle<ProcessModel>(id).pipe(map(value => {
      return plainToInstance(ProcessModel, value.data);
    }));
  }

  addNew(process: ProcessModel) {
    return this.add<ProcessModel>(process, {
      action: 'Post'
    }).pipe(map(value => {
      return plainToInstance(ProcessModel, value.data);
    }));
  }

  save(process: ProcessModel) {
    return this.update<ProcessModel>(process.Id, process).pipe(map(value => {
      return plainToInstance(ProcessModel, value.data);
    }));
  }

  remove(process: ProcessModel) {
    return this.delete<ProcessModel>(process.Id).pipe(map(value => {
      return plainToInstance(ProcessModel, value.data);
    }));
  }

  downloadExcel(ids: string[] = []) {
    return this.http.post(this.getRoute({action: 'ExportToExcel'}), {
      items: ids
    }, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(map(value => {
      return this.getFileNameAndData(value);
    }));
  }

  uploadExcel(file: File): Observable<number> {
    return getBase64(file).pipe(switchMap(fileData => {
      return this.addGet<string, number>(
        fileData,
        { action: 'ImportFromExcel' }
      ).pipe(map(value => {
        return value.data;
      }));
    }));
  }
}
